import React, { Component } from 'react'
import {
    Paper,
    Typography,
    Stepper,
    Step,
    FormControlLabel,
    Checkbox,
} from '@material-ui/core'
import { orgMenuItems, stateMenuItems } from 'shared/helpers';
import { FlatButton, NoLabel, } from 'shared/mui-styles';
import Inputs from './Inputs'
import Modal from 'shared/components/Modal'

const classes = {
    card: {
        width: '640px',
        padding: '2rem 3rem 3rem',
    },
    fullWidth: {
        width: '100%',
    },
    wide: {
        marginLeft: '-3rem',
        marginRight: '-3rem'
    },
    marginBottom: {
        marginBottom: '.8rem',
    },
}

const getSteps = () => {
    return ['Register as New User', 'Database Usage Agreement', 'Create Account'];
}

const Agreement = (props) => {
    const { agree, handleCheckBox } = props;
    return (
        <div>
            <Typography style={classes.marginBottom} variant="body2">
                The HouseATL Data Collective is available for free to persons. By registering for access to download, the user agrees not to use the data in efforts to undermine the mission to preserve the affordability of these properties and they agree to the terms of use outlined in the Terms and Conditions.
            </Typography>
            <Typography style={classes.marginBottom} variant="body2">
                This data access is not intended to be used to redistribute data in their entirety or in part for sale. Users are also granting permission to the Enterprise Community Partners and Georgia Institute of Technology (Georgia Tech) to contact them by e-mail regarding the database.
            </Typography>
            <Typography style={classes.marginBottom} variant="body2">
                We will not share your e-mail address with outside parties.
            </Typography>
            <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '1rem' }}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={agree}
                            onChange={handleCheckBox}
                            value="agree"
                            color="primary"
                        />
                    }
                    label="I Agree"
                    labelPlacement="start"
                />
            </div>
        </div>
    )
}

const Complete = (props) => {
    const { email } = props;
    return (
        <div className="text-center">
            <Typography style={classes.marginBottom} variant="body1">
                Your account was created successfully!
            </Typography>
            <Typography style={classes.marginBottom} variant="body1">
                Check your email (<Typography style={{ fontWeight: 500 }} component="span" variant="body1">{email}</Typography>) for a link to activate your account, then continue to login.
            </Typography>
        </div>
    )
}

class RegisterComponent extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showErrorModal: false,
            localError: '',
            activeStep: 0,
            agree: false,
            fname: '',
            lname: '',
            job: '',
            org: '',
            orgType: '',
            phone: '',
            website: '',
            city: '',
            state: '',
            email: '',
            password: '',
            passwordConfirm: '',
            isRequiredFilledOut: false,
            isAccountFilledOut: false,
        }
    }

    componentDidUpdate(prevProps) {
        const { error, registerSuccess } = this.props;

        if (prevProps.registerSuccess !== registerSuccess && registerSuccess) {
            this.handleNext()
        }

        if (prevProps.error !== error && error) {
            // show a modal with the error...
            this.setState({ showErrorModal: true })
        }
    }

    completeRegistration = () => {
        const { userRegister } = this.props;
        const {
            fname,
            lname,
            job,
            org,
            orgType,
            phone,
            website,
            city,
            state,
            email,
            password,
        } = this.state;

        const payload = {
            username: email,
            lastname: lname,
            firstname: fname,
            email,
            password,
            organization: org,
            data: {
                jobTitle: job,
                orgType,
                phone,
                website,
                city,
                state,
            }
        };

        userRegister(payload);
    }

    handleNext = () => {
        this.setState(prevState => ({
            activeStep: prevState.activeStep + 1,
        }))
    }

    handleBack = () => {
        const { activeStep } = this.state;
        const { history } = this.props;

        if (activeStep === 0) {
            history.push('/user/login');
        } else {
            this.setState(prevState => ({
                activeStep: prevState.activeStep - 1,
            }))
        }
    }

    handleSubmit = (e) => {
        const {
            activeStep,
            password,
            passwordConfirm,
        } = this.state;

        e.preventDefault();

        if (activeStep === 2) {
            const passMatch = password === passwordConfirm;

            if (!passMatch) {
                this.setState({ showErrorModal: true, localError: 'Passwords must match.' })
            } else {
                this.setState({ localError: '' })
                this.props.clearAuthErrors();
                this.completeRegistration();
            }
        } else {
            this.handleNext()
        }
    }

    handleChange = event => {
        this.setState({ [event.target.name]: event.target.value }, () => {
            this.validateRequiredFields()
        })
    }

    handleCheckBox = event => {
        this.setState({ [event.target.value]: event.target.checked })
    }

    validateRequiredFields = () => {
        const {
            activeStep,
            fname,
            lname,
            job,
            org,
            orgType,
            phone,
            city,
            state,
            email,
            password,
            passwordConfirm,
        } = this.state;

        if (activeStep === 0) {
            const fields = [
                fname,
                lname,
                job,
                org,
                orgType,
                phone,
                city,
                state,
            ];
            const isValid = fields.every(currValue => currValue !== '')
            this.setState({ isRequiredFilledOut: isValid })
        }

        if (activeStep === 2) {
            const fields = [
                email,
                password,
                passwordConfirm,
            ];
            const isValid = fields.every(currValue => currValue !== '');
            this.setState({ isAccountFilledOut: isValid })
        }
    }

    render() {
        const {
            showErrorModal,
            isRequiredFilledOut,
            isAccountFilledOut,
            localError,
            activeStep,
            agree,
            fname,
            lname,
            job,
            org,
            orgType,
            phone,
            website,
            city,
            state,
            email,
            password,
            passwordConfirm,
        } = this.state;

        const steps = getSteps();

        const registrationData = [
            {
                dropDown: false,
                value: fname,
                name: 'fname',
                label: 'First Name',
            },
            {
                dropDown: false,
                value: lname,
                name: 'lname',
                label: 'Last Name',
            },
            {
                dropDown: false,
                value: job,
                name: 'job',
                label: 'Job Title',
            },
            {
                dropDown: false,
                value: org,
                name: 'org',
                label: 'Organization',
            },
            {
                dropDown: true,
                value: orgType,
                name: 'orgType',
                menuItems: orgMenuItems,
            },
            {
                dropDown: false,
                value: phone,
                name: 'phone',
                label: 'Phone Number',
            },
            {
                dropDown: false,
                value: website,
                name: 'website',
                label: 'Website (optional)',
            },
            {
                dropDown: false,
                value: city,
                name: 'city',
                label: 'City',
            },
            {
                dropDown: true,
                value: state,
                name: 'state',
                menuItems: stateMenuItems,
            },
        ];

        const accountData = [
            {
                value: email,
                name: 'email',
                label: 'E-mail Address',
            },
            {
                value: password,
                name: 'password',
                label: 'Password',
                type: 'password'
            },
            {
                value: passwordConfirm,
                name: 'passwordConfirm',
                label: 'Confirm Password',
                type: 'password'
            },
        ]

        return (
            <div className="body-center">
                <Paper elevation={1} style={classes.card}>
                    <div>
                        <Stepper activeStep={activeStep} alternativeLabel>
                            {steps.map(label => (
                                <Step key={label}>
                                    <NoLabel>{label}</NoLabel>
                                </Step>
                            ))}
                        </Stepper>
                    </div>
                    <Typography style={{ textAlign: 'center', marginTop: '.8rem', marginBottom: '.8rem' }} variant="h5">
                        {activeStep < 3 ? steps[activeStep] : 'Email Verification'}
                    </Typography>
                    {activeStep === 0 && (
                        <Typography style={{ textAlign: 'center'}} variant="body2">
                            All fields are required unless otherwise noted
                        </Typography>
                    )}
                    <form style={{ padding: '1.2rem 1.4rem 0' }} onSubmit={this.handleSubmit}>

                        {activeStep === 0 && (
                            <Inputs
                                data={registrationData}
                                handleChange={this.handleChange}
                            />
                        )}
                        {activeStep === 1 && (
                            <Agreement
                                agree={agree}
                                handleCheckBox={this.handleCheckBox}
                            />
                        )}
                        {activeStep === 2 && (
                            <Inputs
                                data={accountData}
                                handleChange={this.handleChange}
                            />
                        )}
                        {activeStep === 3 && (
                            <Complete
                                email={email}
                            />
                        )}

                        {activeStep < 3 ? (
                            <div style={{ marginTop: '2.4rem', display: 'flex', justifyContent: 'space-between' }}>
                                <FlatButton
                                    style={{ width: 100 }}
                                    variant="outlined"
                                    onClick={() => { this.handleBack() }}
                                >
                                    {activeStep === 0 ? 'Cancel' : 'Back'}
                                </FlatButton>


                                <FlatButton
                                    style={{ width: 100 }}
                                    variant="contained"
                                    disabled={(activeStep === 0 && !isRequiredFilledOut) || (activeStep === 1 && !agree) || (activeStep === 2 && !isAccountFilledOut)}
                                    color="primary"
                                    type="submit"
                                >
                                    {activeStep === 2 ? 'Complete' : 'Next'}
                                </FlatButton>
                            </div>
                        ) : (
                            <div style={{ marginTop: '2.4rem', display: 'flex', justifyContent: 'center' }}>
                                    <FlatButton
                                        variant="outlined"
                                        onClick={() => { this.props.history.push('/user/login') }}
                                    >
                                        Continue to Login
                                    </FlatButton>
                            </div>
                        )}

                    </form>
                </Paper>
                <Modal
                    maxWidth="xs"
                    visible={showErrorModal}
                    title="Could Not Create Account"
                    content={localError || this.props.error}
                    onClose={() => this.setState({ showErrorModal: false })}
                />
            </div>
        )
    }
}
export default RegisterComponent